import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { Auth } from '@core/services';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Auth);
  const token = authService.token;
  const excludedUrl: string[] = ['/auth/signup', '/auth/login'];

  const isExcluded = excludedUrl.some((url) => req.url.includes(url));

  if (!isExcluded && token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return next(req);
};
